import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
//Apollo
import {ApolloClient} from 'apollo-client';
import {InMemoryCache} from 'apollo-cache-inmemory';
import {HttpLink} from 'apollo-link-http';
//DS
import SelectBase from '../../atomicos/SelectBase';
import SelectGql from '../SelectGql';

const genDefault = (registro) => {
   return registro[Object.keys(registro)[0]];
};

/**
 * Extension de SelectBase para manejo rapido del componente y agregada funcionalidad para consultar a api GraphQl.
 */
const SelectPlus = React.forwardRef(function SelectPlus(props, ref) {
   const {
      //Propiedades del componente
      data,
      entidad,
      campos,
      atributos,
      genId,
      genLabel,
      url,
      //Propiedades del select
      ...other
   } = props;

   const [options, setOptions] = useState([]);
   useEffect(() => {
      if (data) {
         genOptions();
      }
   }, [data]);

   async function genOptions() {
      const newOptions = await Promise.all(
         data.map(async (registro) => {
            return await genElemento(registro);
         })
      );
      setOptions(newOptions);
   }

   const genElemento = async (registro) => {
      const value = await genId(registro);
      const label = await genLabel(registro);
      const dataItem = registro;
      return {value, label, dataItem};
   };

   if (data) {
      return <SelectBase ref={ref} options={options} {...other} />;
   } else {
      if (url) {
         const cache = new InMemoryCache();
         const link = new HttpLink({
            uri: url
         });
         const client = new ApolloClient({
            cache,
            link
         });
         return (
            <SelectGql
               ref={ref}
               entidad={entidad}
               campos={campos}
               atributos={atributos}
               genElemento={genElemento}
               client={client}
               {...other}
            />
         );
      } else {
         return (
            <SelectGql
               ref={ref}
               entidad={entidad}
               campos={campos}
               atributos={atributos}
               genElemento={genElemento}
               {...other}
            />
         );
      }
   }
});

SelectPlus.propTypes = {
   /**
    * Informacion origen de las opciones a mostras en el componente. Si es proporcionada no se tomaran en cuenta las propiedades `entidad` ni `campos`.
    */
   data: PropTypes.arrayOf(PropTypes.object),
   /**
    * Nombre del la consulta GraphQl que se desea utilizando.
    */
   entidad: PropTypes.string,
   /**
    * Campos que se desean recuperar en la consulta.
    */
   campos: PropTypes.arrayOf(PropTypes.string),
   /**
    * Funcion para generar la propiedad `value` del estado del componente componente. Debe aceptar un parametro de tipo objeto con la estructura de los objetos de la propiedad `data` o de los objetos recuperados de la consulta. Debe retornar un `string`.
    */
   genId: PropTypes.func,
   /**
    * Funcion para generar la propiedad `label` del estado del componente componente qu es el valor que se muestra en el deplegable. Debe aceptar un parametro de tipo objeto con la estructura de los objetos de la propiedad `data` o de los objetos recuperados de la consulta. Debe retornar un `string`.
    */
   genLabel: PropTypes.func.isRequired,
   /**
    * Url del servidor GraphQL que se desea utilizar.
    */
   url: PropTypes.string,
   /**
    * Si es true, recuperara la información del api cuando el componente tenga el focus
    */
   recuperarOnFocus: PropTypes.bool
};

SelectPlus.defaultProps = {
   genId: genDefault,
   genLabel: genDefault,
   recuperarOnFocus: false
};

export default SelectPlus;
